import { Navigate, Route } from "react-router-dom";

function pickPortalSession() {
  try {
    if (localStorage.getItem("naturals_partner_userId")) return "partner";
    if (localStorage.getItem("naturals_executive_userId")) return "executive";
    if (localStorage.getItem("naturals_workspace_userId")) return "workspace";
  } catch {
    /* ignore */
  }
  return "workspace";
}

function LegacyMappedRedirect({ map }) {
  const portal = pickPortalSession();
  const to = map[portal] || map.workspace || map.executive || map.partner;
  return <Navigate to={to} replace />;
}

const PATH_MAP = {
  "/naturals/salon-admin/super-admin-dashboard": {
    executive: "/naturals/executive/super-admin-dashboard",
    workspace: "/naturals/workspace/admin-dashboard",
    partner: "/naturals/partner/ib-dashboard",
  },
  "/naturals/salon-admin/hq-admins": {
    executive: "/naturals/executive/hq-admins",
    workspace: "/naturals/workspace/admin-dashboard",
    partner: "/naturals/partner/ib-dashboard",
  },
  "/naturals/salon-admin/admin-dashboard": {
    workspace: "/naturals/workspace/admin-dashboard",
    executive: "/naturals/executive/super-admin-dashboard",
    partner: "/naturals/partner/ib-dashboard",
  },
  "/naturals/salon-admin/ib-dashboard": {
    partner: "/naturals/partner/ib-dashboard",
    workspace: "/naturals/workspace/admin-dashboard",
    executive: "/naturals/executive/super-admin-dashboard",
  },
  "/naturals/salon-admin/check-ins": { partner: "/naturals/partner/check-ins" },
  "/naturals/salon-admin/check-in-analytics": { partner: "/naturals/partner/check-in-analytics" },
  "/naturals/salon-admin/my-orders": { partner: "/naturals/partner/my-orders" },
  "/naturals/salon-admin/kiosk-login": { partner: "/naturals/partner/kiosk-login" },
  "/naturals/salon-admin/store-location": { partner: "/naturals/partner/store-location" },
  "/naturals/salon-admin/kiosk-landings": { workspace: "/naturals/workspace/kiosk-landings" },
  "/naturals/salon-admin/kiosk-register-forms": { workspace: "/naturals/workspace/kiosk-register-forms" },
  "/naturals/salon-admin/kiosk-terms": { workspace: "/naturals/workspace/kiosk-terms" },
  "/naturals/salon-admin/page-setup": { workspace: "/naturals/workspace/page-setup" },
  "/naturals/salon-admin/skin-analysis-settings": { workspace: "/naturals/workspace/skin-analysis-settings" },
  "/naturals/salon-admin/productlist": { workspace: "/naturals/workspace/productlist" },
  "/naturals/salon-admin/servicelist": { workspace: "/naturals/workspace/servicelist" },
  "/naturals/salon-admin/franchise-users": { workspace: "/naturals/workspace/franchise-users" },
  "/naturals/salon-admin/whatsapp-credentials": { workspace: "/naturals/workspace/whatsapp-credentials" },
  "/naturals/salon-admin/admin-contact-messages": { workspace: "/naturals/workspace/admin-contact-messages" },
  "/naturals/salon-admin/company-profile": {
    workspace: "/naturals/workspace/company-profile",
    executive: "/naturals/executive/company-profile",
  },
  "/naturals/salon-admin/complaints": {
    partner: "/naturals/partner/complaints",
    executive: "/naturals/executive/complaints",
    workspace: "/naturals/workspace/admin-dashboard",
  },
  "/naturals/salon-admin/naturals-kpis": {
    partner: "/naturals/partner/naturals-kpis",
    executive: "/naturals/executive/naturals-kpis",
    workspace: "/naturals/workspace/admin-dashboard",
  },
  "/naturals/salon-admin/store-location-requests": {
    workspace: "/naturals/workspace/store-location-requests",
  },
  "/naturals/salon-admin/edit-profile": {
    workspace: "/naturals/workspace/edit-profile",
    executive: "/naturals/executive/edit-profile",
    partner: "/naturals/partner/edit-profile",
  },
};

export function renderSalonAdminLegacyRedirects() {
  return (
    <>
      <Route path="/naturals/salon-admin" element={<Navigate to="/naturals/workspace" replace />} />
      <Route path="/naturals/super-admin" element={<Navigate to="/naturals/executive" replace />} />
      <Route path="/naturals/franchise-admin" element={<Navigate to="/naturals/partner" replace />} />
      {Object.entries(PATH_MAP).map(([from, map]) => (
        <Route key={from} path={from} element={<LegacyMappedRedirect map={map} />} />
      ))}
      <Route
        path="/naturals/salon-admin/*"
        element={<Navigate to="/naturals/workspace" replace />}
      />
    </>
  );
}

/** @deprecated Use renderSalonAdminLegacyRedirects */
export function renderSalonAdminRoutes() {
  return renderSalonAdminLegacyRedirects();
}
